import { AuthAmbientBackdrop } from './AuthAmbientBackdrop';
import styles from './Login.module.css';

export type AuthBrandedLoaderProps = {
  message?: string;
};

/** Same gradient + rings as login; rings/grid drift slowly via one CSS transform (lightweight). */
export function AuthBrandedLoader({ message = 'Please wait…' }: AuthBrandedLoaderProps) {
  return (
    <div className={styles.authBrandedLoaderRoot} role='status' aria-live='polite' aria-busy='true'>
      <div className={styles.authBrandedLoaderBackdrop} aria-hidden={true}>
        <AuthAmbientBackdrop />
      </div>
      <div className={styles.authBrandedLoaderContent}>
        <div className={styles.authBrandedLoaderSpinner} />
        <p className={styles.authBrandedLoaderText}>{message}</p>
      </div>
    </div>
  );
}
